import React from "react";

const GlobalLoader = () => (
  <div className="w-full max-w-screen-xl mx-auto p-6 bg-white rounded shadow animate-pulse">
    <div className="flex flex-col md:flex-row gap-6">
      <div className="w-full md:w-64 h-64 bg-gray-300 rounded" />
      <div className="flex-1 space-y-3">
        <div className="h-6 bg-gray-300 rounded w-1/3"></div>
        <div className="h-4 bg-gray-300 rounded w-2/3"></div>
        <div className="h-4 bg-gray-300 rounded w-1/2"></div>
        <div className="h-4 bg-gray-300 rounded w-1/4"></div>
      </div>
    </div>

    <div className="mt-6 space-y-3">
      {[...Array(8)].map((_, idx) => (
        <div key={idx} className="h-4 bg-gray-300 rounded w-full"></div>
      ))}
    </div>
  </div>
);

export default GlobalLoader;
